import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// One reference per speaker, shared by both halves. Reuse English already on screen.
export default function useDeskEnglish(transcript, sourceLanguage, targetLanguage) {
  const original = transcript?.source || "", translated = transcript?.translation || "";
  const direct = sourceLanguage === "en" ? original : targetLanguage === "en" ? translated : null;
  const text = direct === null ? original : direct;
  const key = `${sourceLanguage}\0${targetLanguage}\0${text}`;
  const [result, setResult] = useState({ key: "", text: "", status: "idle" });
  const [available, setAvailable] = useState(() => navigator.onLine !== false && document.visibilityState !== "hidden");
  useEffect(() => {
    const changed = () => setAvailable(navigator.onLine !== false && document.visibilityState !== "hidden");
    window.addEventListener("online", changed); window.addEventListener("offline", changed); document.addEventListener("visibilitychange", changed);
    return () => { window.removeEventListener("online", changed); window.removeEventListener("offline", changed); document.removeEventListener("visibilitychange", changed); };
  }, []);
  useEffect(() => {
    if (direct !== null || !text.trim() || !sourceLanguage || !targetLanguage || !available) return undefined;
    let current = true;
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      try {
        const { data } = await api.post("/admin/first-line-desk/english-reference", { source_language: sourceLanguage, text }, { signal: controller.signal, timeout: 30000 });
        if (typeof data.english_text !== "string" || !data.english_text.trim() || data.english_text.length > 12000) throw new Error("Invalid English reference");
        if (current) setResult({ key, text: data.english_text, status: "ready" });
      } catch { if (current) setResult({ key, text: "", status: "error" }); }
    }, 1200);
    return () => { current = false; clearTimeout(timer); controller.abort(); };
  }, [direct, text, sourceLanguage, targetLanguage, key, available]);
  if (!sourceLanguage || !targetLanguage || !text.trim()) return { text: "", status: "idle" };
  if (direct !== null) return { text: direct, status: "ready" };
  if (!available) return { text: "", status: "offline" };
  return result.key === key ? result : { text: "", status: "pending" };
}
